/*global jQuery*/
/**
 * Entry: wordlift-admin-user-profile-page.js
 *
 * @since 3.14.0
 */

/**
 * Internal dependencies
 */
import './styles/index.scss'
import Select2 from 'modules/select2'

/**
 * UI interactions on the WordLift Settings page
 *
 * @since 3.14.0
 */
(($) => {
  $(function () {
    // Create the Select2.
    Select2('.wl-select2-element')
  })
})(jQuery)



// WEBPACK FOOTER //
// ./src-js/screens/Admin/components/AuthorSelect/index.js